/* eslint-disable ember/classic-decorator-no-classic-methods, ember/no-classic-components, ember/no-get, ember/require-tagless-components */
import Component from '@ember/component';
import { service } from '@ember/service';
import { isEmpty } from '@ember/utils';
import { action } from '@ember/object';
import GoalState from '@linc-technologies/linced-common/enums/goal-state';
import { saveOrDiscard } from '@linc-technologies/linced-common/utils/record-rollback';

export default class GoalGrader extends Component {
  @service
  session;

  @service
  store;

  @service
  toaster;

  refreshStates() {}
  updateState() {}
  state = null;
  goal = null;
  person = null;
  inline = false;
  parentView = false;

  @action
  async addGrade(grade) {
    let state = this.state;
    let newGrade = false;
    if (isEmpty(state) || !state.grade) {
      newGrade = true;
      state = this.store.createRecord('goals/state', {
        schoolId: this.get('session.school'),
        assessorId: this.get('session.person'),
        personId: this.person,
        // The goal card can give the async proxy. WarpDrive accepts only a record.
        goalId: await this.goal,
        awarded: GoalState.SECURE,
      });
    }
    state.set('grade', grade.value);
    saveOrDiscard(state)
      .then(() => {
        if (!isEmpty(this.updateState) && newGrade) {
          this.updateState(state);
        }
        this.refreshStates();
      })
      .catch(() => this.toaster.error('Error saving the goal state.'));
  }

  @action
  clearGrade() {
    let state = this.state;
    if (isEmpty(state)) {
      return;
    }
    state.set('grade', 0);
    saveOrDiscard(state)
      .then(() => {
        this.refreshStates();
      })
      .catch(() => this.toaster.error('Error saving the goal state.'));
  }

  @action
  noOp() {}
}
